import React, { useEffect, useMemo, useRef, useState } from 'react';

import { Modal } from 'flowbite';

import ProcurementApprovalsTable from './ProcurementApprovalsTable';

import { modalOptions } from 'Helpers/modalOptions';

import CheckboxInput from 'CommonComponents/CheckboxInput';

export default function ProcurementApprovalsIndex(props) {
    const queryParams = new URLSearchParams(window.location.search);

    const [dataSet, setDataSet] = useState({});
    const [users, setUsers] = useState(props.users);
    const [departments, setDepartments] = useState([]);
    const [costcenters, setCostcenters] = useState([]);
    const [departmentId, setDepartmentId] = useState('all');
    const [costcenterId, setCostcenterId] = useState('');
    const [ownerId, setOwnerId] = useState('');

    const [fetched, setFetched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [procurementModalElement, setProcurementModalElement] = useState(null);
    const [currentProcurement, setCurrentProcurement] = useState(null);
    const [myApprovals, setMyApprovals] = useState(false);

    const procurementInfoModalRef = useRef();

    const filters = useMemo(
        () => ({
            owner_id: ownerId || null,
            department_id: departmentId !== 'all' ? departmentId : null,
            costcenter_id: costcenterId || null,
            my_approvals: myApprovals ? 1 : null,
        }),
        [ownerId, departmentId, costcenterId, myApprovals],
    );

    useEffect(() => {
        const depData = [{ id: 'all', name: 'All Departments', costcenters: [] }];
        props.departments.forEach((dep) => {
            depData.push({ id: dep.id, name: dep.name, costcenters: dep.costcenters });
        });
        setDepartments(depData);

        procurementInfoModalRef && setProcurementModalElement(new Modal(procurementInfoModalRef.current, modalOptions(false)));
    }, []);

    useEffect(() => {
        if (procurementModalElement) {
            const procurementId = queryParams.get('procurement_id');
            if (procurementId) {
                showProcurementInfoModal(procurementId);
            }
        }
    }, [procurementModalElement]);

    useEffect(() => {
        fetchData();
    }, [filters]);

    const fetchProcurement = (id) => {
        if (id) {
            const url = props.fetchProcurementPlanItemUrl.replace('ITEM_ID', id);
            setLoading(true);

            axios
                .get(url)
                .then(({ data }) => {
                    setCurrentProcurement(data);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const showProcurementInfoModal = (id) => {
        fetchProcurement(id);
        procurementModalElement && procurementModalElement.show();
    };

    const closeModal = () => {
        setCurrentProcurement(null);
        procurementModalElement && procurementModalElement.hide();
    };

    const fetchData = () => {
        axios
            .get(props.fetchUrl, {
                params: { ...filters },
            })
            .then(({ data }) => {
                setDataSet(data);
            })
            .catch((e) => {
                console.log(e.response);
            })
            .finally(() => {
                setFetched(true);
            });
    };

    useEffect(() => {
        if (departmentId && departmentId !== 'all') {
            const department = departments.find((item) => {
                return item.id === parseInt(departmentId);
            });
            setCostcenters(department?.costcenters || []);
        } else {
            setCostcenterId('');
            setCostcenters([]);
        }
    }, [departmentId]);

    const changeOwner = (e) => {
        const val = e.target.value;
        setOwnerId(val || '');
    };

    const changeDepartment = (e) => {
        const val = e.target.value;
        setDepartmentId(val || 'all');
    };

    const changeCostcenter = (e) => {
        const val = e.target.value;
        setCostcenterId(val || '');
    };

    return (
        <>
            <div className="table__card tw-mx-3 tw-my-2 cursor-pointer">
                <div className="tw-flex tw-flex-row tw-items-stretch">
                    <div className="tw-basis-4/12 tw-mx-3">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor={'owner'} className="tw-text-charcoal tw-text-sm tw-mb-0">
                                {$t('Owner')}
                            </label>
                            <select className={'tw-border-0 select-input'} value={ownerId} onChange={changeOwner}>
                                <option value={''}>{$t('All')}</option>
                                <option value={'no_owner'}>{$t('No Owner')}</option>
                                {users.map((user) => {
                                    return (
                                        <option key={user.id} value={user.id}>
                                            {user.first_name + ' ' + user.last_name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>

                    <div className="tw-basis-4/12 tw-mx-3">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label htmlFor={'department'} className="tw-text-charcoal tw-text-sm tw-mb-0">
                                {$t('Department')}
                            </label>
                            <select className={'tw-border-0 select-input'} value={departmentId} onChange={changeDepartment}>
                                {departments.map((department) => {
                                    return (
                                        <option key={department.id} value={department.id}>
                                            {department.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                        {costcenters.length > 0 && (
                            <div className="tw-flex tw-flex-col tw-space-y-1.5">
                                <label htmlFor={'costcenter'} className="tw-text-charcoal tw-text-sm tw-mb-0">
                                    {$t('Costcenter')}
                                </label>
                                <select className={'tw-border-0 select-input'} value={costcenterId} onChange={changeCostcenter}>
                                    <option value={''}>{$t('Choose Cost Center')}</option>
                                    <option value={'empty'}>{$t('Empty')}</option>
                                    {costcenters.map((costcenter) => {
                                        return (
                                            <option key={costcenter.id} value={costcenter.id}>
                                                {costcenter.name}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        )}
                    </div>
                    <div className="tw-basis-4/12 tw-mx-3 tw-flex tw-items-end tw-mb-1">
                        <CheckboxInput
                            name="myApprovals"
                            id="myApprovals"
                            defaultChecked={!!myApprovals}
                            value={myApprovals}
                            label={$t('My Approvals')}
                            onChange={() => setMyApprovals(!myApprovals)}
                        />
                    </div>
                </div>
            </div>

            <ProcurementApprovalsTable
                groups={props.groups}
                dataSet={dataSet}
                fetched={fetched}
                showProcurementInfoModal={showProcurementInfoModal}
                closeModal={closeModal}
                loading={loading}
                procurementInfoModalRef={procurementInfoModalRef}
                procurementModalElement={procurementModalElement}
                procurement={currentProcurement}
                listUsersUrl={props.listUsersUrl}
                downloadAttachmentUrl={props.downloadProcurementPlanItemAttachmentUrl}
            />
        </>
    );
}
